import React, { useState, useEffect, useRef } from "react";
import DevelopersLogin from "../../assets/images/developers_login.png";
import DevelopersSmsOtp from "../../assets/images/developers_sms_otp.png";
import DevelopersSandbox from "../../assets/images/developers_sandbox.png";
import SandboxProjectDetails from "../../assets/images/sandbox_project_details.png";
import SandboxProject from "../../assets/images/sandbox_project.png";
import DevelopersSandboxCredentials from "../../assets/images/developers_sandbox_credentials.png";
import DevelopersHamburgerMenu from "../../assets/images/developers_hamburger_menu.png";
import DevelopersDownloadsSidebar from "../../assets/images/developers_downloads_sidebar.png";
import ResourceDownloadsSidebar from "../../assets/images/resource_downloads_sidebar.png";
import ResourceSandbox from "../../assets/images/resource_sandbox.png";
import ResourcePolyFinTechPaytech from "../../assets/images/resource_polyfintech_paytech.png";
import SandboxCourseCertificate from "../../assets/images/sandbox_course_certificate.png";
import SandboxCourseCertificateDetails from "../../assets/images/sandbox_course_certificate_details.png";
import CertificationFormSandbox from "../../assets/images/certification_form_sandbox.png";
import Header from "../components/developer_header.jsx";
import Footer from "../components/developer_footer.jsx";
import SandboxNetsQrWebInspect from "../../assets/images/sandbox_nets_qr_web_inspect.png";
import SandboxNetsQrWebConsole from "../../assets/images/sandbox_nets_qr_web_console.png";
import SandboxNetsQrWebSuccess from "../../assets/images/sandbox_nets_qr_web_success.png";
import SandboxNetsQrMobileRetrievalRef from "../../assets/images/sandbox_nets_qr_mobile_retrieval_ref.png";
import SandboxEnetsWebHome from "../../assets/images/sandbox_enets_web_home.png";
import SandboxEnetsWebPaymentMethods from "../../assets/images/sandbox_enets_web_payment_methods.png";
import SandboxEnetsWebInspect from "../../assets/images/sandbox_enets_web_inspect.png";
import SandboxEnetsWebConsole from "../../assets/images/sandbox_enets_web_console.png";
import SandboxEnetsWebDebitSuccess from "../../assets/images/sandbox_enets_web_debit_success.png";
import SandboxEnetsWebCreditSuccess from "../../assets/images/sandbox_enets_web_credit_success.png";
import SandboxEnetsWebQrSuccess from "../../assets/images/sandbox_enets_web_qr_success.png";
import SandboxEnetsWebDebitCreditFail from "../../assets/images/sandbox_enets_web_debit_credit_fail.png";
import SandboxEnetsWebQrFail from "../../assets/images/sandbox_enets_web_qr_fail.png";
import SandboxNetsQrWebFail from "../../assets/images/sandbox_nets_qr_web_fail.png";
import CertificationFormSandboxNetsQrWebSuccess from "../../assets/images/certification_form_sandbox_nets_qr_web_success.png";
import CertificationFormSandboxNetsQrWebTimeout from "../../assets/images/certification_form_sandbox_nets_qr_web_timeout.png";
import SandboxNetsQrMobileHome from "../../assets/images/sandbox_nets_qr_mobile_home.png";
import SandboxNetsQrMobile from "../../assets/images/sandbox_nets_qr_mobile.png"
import SandboxNetsQrMobileSuccess from "../../assets/images/sandbox_nets_qr_mobile_success.png"
import SandboxNetsQrMobileFail from "../../assets/images/sandbox_nets_qr_mobile_fail.png";
import CertificationFormSandboxNetsQrMobileSuccess from "../../assets/images/certification_form_sandbox_nets_qr_mobile_success.png"
import CertificationFormSandboxNetsQrMobileTimeout from "../../assets/images/certification_form_sandbox_nets_qr_mobile_timeout.png"
import CertificationFormSandboxEnetsWebDebitSuccess from "../../assets/images/certification_form_sandbox_enets_web_debit_success.png"
import CertificationFormSandboxEnetsWebCreditSuccess from "../../assets/images/certification_form_sandbox_enets_web_credit_success.png"
import CertificationFormSandboxEnetsWebQrSuccess from "../../assets/images/certification_form_sandbox_enets_web_qr_success.png"
import CertificationFormSandboxEnetsWebDebitCreditTimeout from "../../assets/images/certification_form_sandbox_enets_web_debit_credit_timeout.png"
import CertificationFormSandboxEnetsWebQrTimeout from "../../assets/images/certification_form_sandbox_enets_web_qr_timeout.png"
import CertificationStatusReleased from "../../assets/images/certification_status_released.png"


const SandboxNetsCertificationLayout = () => {
  const [activeStep, setActiveStep] = useState(1);
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);
  const [activePaymentMethod, setActivePaymentMethod] = useState('nets-qr-web');
  
  // Add state for image modal
  const [imageModal, setImageModal] = useState({
    isOpen: false,
    imageSrc: ""
  });
  
  // Create refs for each step section
  const step1Ref = useRef(null);
  const step2Ref = useRef(null);
  const step3Ref = useRef(null);
  const step4Ref = useRef(null);
  const step5Ref = useRef(null);
  const step6Ref = useRef(null);
  const step7Ref = useRef(null);
  
  // Function to open image modal
  const openImageModal = (imageSrc) => {
    setImageModal({ 
      isOpen: true,
      imageSrc: imageSrc
    });
  };
  
  // Function to close image modal
  const closeImageModal = () => {
    setImageModal({
      isOpen: false,
      imageSrc: ""
    });
  };
  
  // Setup intersection observer to detect which step is in view
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "-100px 0px -60% 0px", // Adjust these values as needed
      threshold: 0
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const stepId = parseInt(entry.target.getAttribute('data-step'));
          setActiveStep(stepId);
          
          // Check if this is a payment method section
          const paymentMethod = entry.target.getAttribute('data-payment-method');
          if (paymentMethod && stepId === 6) {
            setActivePaymentMethod(paymentMethod);
          }
        }
      });
    }, options);
    
    // Options for payment method observer (more sensitive)
    const paymentMethodOptions = {
      root: null,
      rootMargin: "-200px 0px -40% 0px",
      threshold: 0.1
    };
    
    const paymentMethodObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const paymentMethod = entry.target.id.replace('payment-method-', '');
          setActivePaymentMethod(paymentMethod);
        }
      });
    }, paymentMethodOptions);
    
    // Observe all step elements
    if (step1Ref.current) observer.observe(step1Ref.current);
    if (step2Ref.current) observer.observe(step2Ref.current);
    if (step3Ref.current) observer.observe(step3Ref.current);
    if (step4Ref.current) observer.observe(step4Ref.current);
    if (step5Ref.current) observer.observe(step5Ref.current);
    if (step6Ref.current) observer.observe(step6Ref.current);
    if (step7Ref.current) observer.observe(step7Ref.current);
    
    // Observe payment method elements
    const paymentMethodElements = [
      document.getElementById('payment-method-nets-qr-web'),
      document.getElementById('payment-method-nets-qr-mobile'),
      document.getElementById('payment-method-enets-web')
    ];
    
    paymentMethodElements.forEach(element => {
      if (element) paymentMethodObserver.observe(element);
    });
    
    return () => {
      // Clean up observer on component unmount
      if (step1Ref.current) observer.unobserve(step1Ref.current);
      if (step2Ref.current) observer.unobserve(step2Ref.current);
      if (step3Ref.current) observer.unobserve(step3Ref.current);
      if (step4Ref.current) observer.unobserve(step4Ref.current);
      if (step5Ref.current) observer.unobserve(step5Ref.current);
      if (step6Ref.current) observer.unobserve(step6Ref.current);
      if (step7Ref.current) observer.unobserve(step7Ref.current);
      
      // Clean up payment method observer
      paymentMethodElements.forEach(element => {
        if (element) paymentMethodObserver.unobserve(element);
      });
    };
  }, []);

  // Scroll to specific step when clicking on sidebar links
  const scrollToStep = (stepId) => {
    const element = document.getElementById(`step${stepId}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    // Close mobile sidebar after selecting a step
    setShowMobileSidebar(false);
  };

  // Scroll to specific payment method within Step 6
  const scrollToPaymentMethod = (method) => {
    setActivePaymentMethod(method);
    setActiveStep(6); // Ensure Step 6 is active
    const element = document.getElementById(`payment-method-${method}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    // Close mobile sidebar after selecting a method
    setShowMobileSidebar(false);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header/>
      
      {/* Image Modal */}
      {imageModal.isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
          onClick={closeImageModal}
        >
          <div className="relative max-w-[90vw] max-h-[90vh]">
            <button 
              className="absolute top-2 right-2 bg-white rounded-full p-2 text-gray-800 hover:text-gray-600 focus:outline-none"
              onClick={closeImageModal}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <img 
              src={imageModal.imageSrc} 
              alt="Enlarged view"
              className="max-w-full max-h-[85vh] object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()} // Prevent closing when clicking on the image itself
            />
          </div>
        </div>
      )}

      {/* Sticky Breadcrumb - adjusted for mobile */}
      <div className="sticky top-0 z-10 bg-gray-100 py-2 sm:py-3 shadow-md">
        <div className="container mx-auto px-4 sm:px-6 text-left">
          <p className="text-xs sm:text-sm text-gray-600 text-left truncate">
            <a href="/get-started" className="text-blue-600 hover:underline">Get Started</a> &gt; 
            <a href="/certification-journey" className="text-blue-600 hover:underline"> Certification Journey</a> &gt; 
            <span className="hidden sm:inline"> NETS Certification Process (Sandbox)</span>
            <span className="inline sm:hidden"> Sandbox</span>
          </p>
        </div>
      </div>

      {/* Mobile Step Navigator - only visible on mobile */}
      <div className="md:hidden sticky top-10 z-10 bg-white shadow-md py-2 px-4">
        <div className="flex justify-between items-center">
          <div className="text-sm font-medium">
            Step {activeStep} of 7
          </div>
          <button 
            onClick={() => setShowMobileSidebar(!showMobileSidebar)}
            className="bg-blue-600 text-white px-3 py-1 rounded-md text-sm"
          >
            {showMobileSidebar ? 'Hide Steps' : 'Show Steps'}
          </button>
        </div>
        
        {/* Mobile Sidebar - collapsible */}
        {showMobileSidebar && (
          <div className="mt-3 pb-2 border-t pt-2">
            <ul className="space-y-3 text-sm">
              {[1, 2, 3, 4, 5, 6, 7].map(step => (
                <div key={step}>
                  <li 
                    className={`${activeStep === step ? "text-blue-600 font-medium" : "text-gray-700"} 
                      text-left transition-colors duration-300 cursor-pointer hover:text-blue-500
                      py-1`}
                    onClick={() => scrollToStep(step)}
                  >
                    Step {step} | {step === 1 ? "Setup account" :
                                   step === 2 ? "Create project" :
                                   step === 3 ? "Fill details" :
                                   step === 4 ? "Get API key" :
                                   step === 5 ? "Download resources" : 
                                   step === 6 ? "Retrieve txn details" : 
                                   "Get certified"}
                  </li>
                  {/* Sub-navigation for Step 6 in mobile */}
                  {step === 6 && activeStep === 6 && (
                    <div className="ml-4 space-y-2 mt-1">
                      <div 
                        className={`${activePaymentMethod === 'nets-qr-web' ? "text-blue-500 font-medium" : "text-gray-600"} text-xs transition-colors duration-300 cursor-pointer hover:text-blue-400 py-1`}
                        onClick={() => scrollToPaymentMethod('nets-qr-web')}
                      >
                        • NETS QR (Web)
                      </div>
                      <div 
                        className={`${activePaymentMethod === 'nets-qr-mobile' ? "text-blue-500 font-medium" : "text-gray-600"} text-xs transition-colors duration-300 cursor-pointer hover:text-blue-400 py-1`}
                        onClick={() => scrollToPaymentMethod('nets-qr-mobile')}
                      >
                        • NETS QR (Mobile)
                      </div>
                      <div 
                        className={`${activePaymentMethod === 'enets-web' ? "text-blue-500 font-medium" : "text-gray-600"} text-xs transition-colors duration-300 cursor-pointer hover:text-blue-400 py-1`}
                        onClick={() => scrollToPaymentMethod('enets-web')}
                      >
                        • eNETS (Web)
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </ul>
          </div>
        )}
      </div>

      {/* Main Content - improved responsive layout */}
      <main className="container mx-auto px-4 sm:px-6 py-6 sm:py-12 grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 text-left">
        
        {/* Sidebar - hidden on mobile, visible on desktop */}
        <aside className="hidden md:block bg-white rounded-lg shadow-md p-4 sm:p-6 text-left md:sticky md:top-16 self-start">
          <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-4 text-left">In this Tutorial</h3>
          <ul className="space-y-4 text-sm text-left">
            <li 
              className={`${activeStep === 1 ? "text-blue-600 font-medium" : "text-black"} text-left transition-colors duration-300 cursor-pointer hover:text-blue-500`}
              onClick={() => scrollToStep(1)}
            >
              Step 1 | Setup OPENAPIPASS developer account
            </li>
            <li 
              className={`${activeStep === 2 ? "text-blue-600 font-medium" : "text-black"} text-left transition-colors duration-300 cursor-pointer hover:text-blue-500`}
              onClick={() => scrollToStep(2)}
            >
              Step 2 | Create your Sandbox project
            </li>
            <li 
              className={`${activeStep === 3 ? "text-blue-600 font-medium" : "text-black"} text-left transition-colors duration-300 cursor-pointer hover:text-blue-500`}
              onClick={() => scrollToStep(3)}
            >
              Step 3 | Fill in the details of your Sandbox project
            </li>
            <li 
              className={`${activeStep === 4 ? "text-blue-600 font-medium" : "text-black"} text-left transition-colors duration-300 cursor-pointer hover:text-blue-500`}
              onClick={() => scrollToStep(4)}
            >
              Step 4 | Retrieve project id and api key
            </li>
            <li 
              className={`${activeStep === 5 ? "text-blue-600 font-medium" : "text-black"} text-left transition-colors duration-300 cursor-pointer hover:text-blue-500`}
              onClick={() => scrollToStep(5)}
            >
              Step 5 | Download the resources
            </li>
            <li 
              className={`${activeStep === 6 ? "text-blue-600 font-medium" : "text-black"} text-left transition-colors duration-300 cursor-pointer hover:text-blue-500`}
              onClick={() => scrollToStep(6)}
            >
              Step 6 | Retrieving your txn_id and txn_retrieval_ref
            </li>
            {/* Sub-navigation for Step 6 payment methods */}
            {activeStep === 6 && (
              <div className="ml-4 space-y-2 mt-2">
                <div 
                  className={`${activePaymentMethod === 'nets-qr-web' ? "text-blue-500 font-medium" : "text-gray-600"} text-sm transition-colors duration-300 cursor-pointer hover:text-blue-400`}
                  onClick={() => scrollToPaymentMethod('nets-qr-web')}
                >
                  • NETS QR (Web)
                </div>
                <div 
                  className={`${activePaymentMethod === 'nets-qr-mobile' ? "text-blue-500 font-medium" : "text-gray-600"} text-sm transition-colors duration-300 cursor-pointer hover:text-blue-400`}
                  onClick={() => scrollToPaymentMethod('nets-qr-mobile')}
                >
                  • NETS QR (Mobile)
                </div>
                <div 
                  className={`${activePaymentMethod === 'enets-web' ? "text-blue-500 font-medium" : "text-gray-600"} text-sm transition-colors duration-300 cursor-pointer hover:text-blue-400`}
                  onClick={() => scrollToPaymentMethod('enets-web')}
                >
                  • eNETS (Web)
                </div>
              </div>
            )}
            <li 
              className={`${activeStep === 7 ? "text-blue-600 font-medium" : "text-black"} text-left transition-colors duration-300 cursor-pointer hover:text-blue-500`}
              onClick={() => scrollToStep(7)}
            >
              Step 7 | Get certified
            </li>
          </ul>
        </aside>
        
        {/* Main Section - adjustments for mobile */}
        <section className="col-span-1 md:col-span-2 text-left">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-3 sm:mb-4 text-left">NETS Coursework Certification Process (Sandbox)</h2>
          <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
            This tutorial will guide you towards implementing and certifying NETS payment gateways in a Sandbox environment.
          </p>
          <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
            In software development, a Sandbox is a testing environment that isolates untested code changes and outright experimentation from the Production environment.
          </p>
          <p className="text-sm sm:text-base text-gray-700 mb-3 sm:mb-4 text-left">
            <strong>Scope:</strong>
          </p>
          <ul className="list-disc list-inside text-left mb-4 sm:mb-6 pl-2">
            <li className="text-sm sm:text-base text-gray-700 text-left">Equip students with NETS payment know-how</li>
            <li className="text-sm sm:text-base text-gray-700 text-left">Not connected to merchant payment gateways and merchant web services</li>
          </ul>
          <p className="text-sm sm:text-base text-gray-700 mb-6 text-left">
            Follow the steps below to get started on your NETS Certification Process in a Sandbox environment!
          </p>

          {/* Step 1 */}
          <div id="step1" ref={step1Ref} data-step="1" className="scroll-mt-24 mb-8 sm:mb-12">
            <h3 className="text-lg font-semibold text-gray-800 mb-3 sm:mb-4 text-left">Step 1 | Setup OPENAPIPASS developer account</h3>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Go to the website <a href="https://developers.openapipass.org/homepage" className="text-blue-600 hover:underline break-all">https://developers.openapipass.org/homepage</a> to set up your developer account. Input your mobile number and login. Click on 'Get SMS OTP'. On receiving the SMS OTP, click on 'Proceed' button.
            </p>
            <div className="flex flex-col space-y-4">
              <img
                src={DevelopersLogin}
                alt="NETS Certification Process Sandbox"
                className="shadow-md rounded-md w-full max-w-md ml-0 cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(DevelopersLogin)}
              />
              <img
                src={DevelopersSmsOtp}
                alt="NETS Certification Process Sandbox"
                className="shadow-md rounded-md w-full max-w-md ml-0 cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(DevelopersSmsOtp)}
              />
            </div>
          </div>

          {/* Step 2 */}
          <div id="step2" ref={step2Ref} data-step="2" className="scroll-mt-24 mb-8 sm:mb-12">
            <h3 className="text-lg font-semibold text-gray-800 mb-3 sm:mb-4 text-left">Step 2 | Create your own Sandbox project</h3>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Once logged in, click on 'Sandbox' icon.
            </p>
            <img
              src={DevelopersSandbox}
              alt="NETS Certification Process Sandbox"
              className="shadow-md rounded-md mb-4 w-full max-w-md ml-0 cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(DevelopersSandbox)}
            />
          </div>

          {/* Step 3 */}
          <div id="step3" ref={step3Ref} data-step="3" className="scroll-mt-24 mb-8 sm:mb-12">
            <h3 className="text-lg font-semibold text-gray-800 mb-3 sm:mb-4 text-left">Step 3 | Fill in the details of your Sandbox project</h3>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              For the Sandbox project, input these details: 
              <br className="mb-1"/>Sandbox Name: NETS Coursework
              <br className="mb-1"/>API: sandbox_nets
              <br className="mb-1"/>Project Website URL: http://localhost:3000
              <br className="mb-1"/>Once you have done entering the details, click on 'Create' button.
            </p>
            <img
              src={SandboxProjectDetails}
              alt="NETS Certification Process Sandbox"
              className="shadow-md rounded-md mb-4 w-full max-w-md ml-0 cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(SandboxProjectDetails)}
            />
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              After creating the Sandbox project, click on the project you have just created.
            </p>
            <img
              src={SandboxProject}
              alt="NETS Certification Process Sandbox"
              className="shadow-md rounded-md mb-4 w-full max-w-md ml-0 cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(SandboxProject)}
            />
          </div>

          {/* Step 4 */}
          <div id="step4" ref={step4Ref} data-step="4" className="scroll-mt-24 mb-8 sm:mb-12">
            <h3 className="text-lg font-semibold text-gray-800 mb-3 sm:mb-4 text-left">Step 4 | Retrieve project id and api key</h3>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              After clicking on the project you have created, the project id and the API key will be displayed. Click on 'Click here to view API key' button to display the API key.
            </p>
            <img 
              src={DevelopersSandboxCredentials}
              alt="NETS Certification Process Sandbox"
              className="shadow-md rounded-md mb-4 w-full max-w-md ml-0 cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(DevelopersSandboxCredentials)}
            />
          </div>

          {/* Step 5 */}
          <div id="step5" ref={step5Ref} data-step="5" className="scroll-mt-24 mb-8 sm:mb-12">
            <h3 className="text-lg font-semibold text-gray-800 mb-3 sm:mb-4 text-left">Step 5 | Download the resources</h3>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Click on menu icon at the top left corner of the webpage.
            </p>
            <img 
              src={DevelopersHamburgerMenu}
              alt="NETS Certification Process Sandbox"
              className="shadow-md rounded-md mb-4 w-full max-w-md ml-0 cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(DevelopersHamburgerMenu)}
            />
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Click on 'Resources', navigate to 'Downloads'.
            </p>
            <img
              src={ResourceDownloadsSidebar}
              alt="NETS Certification Process Sandbox"
              className="shadow-md rounded-md mb-4 w-full max-w-md ml-0 cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(ResourceDownloadsSidebar)}
            />
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-justify">
              Do note, if you are downloading PolyFinTech Skills Development Resources, go to PayTech folder in the left image. Else, if you are downloading school coursework resources, go to Sandbox environment folder in the right image. For the passcode, you may check with your course instructor.
            </p>
          <div className="flex flex-col sm:flex-row gap-4 mb-4 items-center justify-center">
            <img
              src={ResourcePolyFinTechPaytech}
              alt="NETS Download Folder Sandbox"
              className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(ResourcePolyFinTechPaytech)}
            />
            <span className="text-gray-600 font-bold text-sm sm:text-base sm:flex-shrink-0">OR</span>
            <img
              src={ResourceSandbox}
              alt="NETS Download Folder PayTech"
              className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(ResourceSandbox)}
            />
          </div>
          </div>

          {/* Step 6 */}
          <div id="step6" ref={step6Ref} data-step="6" className="scroll-mt-24 mb-8 sm:mb-12">
            <h3 className="text-lg font-semibold text-gray-800 mb-3 sm:mb-4 text-left">Step 6 | Retrieving txn_id and txn_retrieval_ref</h3>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              After completing your NETS coursework, you'll need to retrieve the transaction details for certification. The process varies depending on what coursework you started on. Follow the instructions for your specific payment method below:
            </p>
            
            {/* NETS QR Web Section */}
            <div id="payment-method-nets-qr-web" className="mb-8 scroll-mt-32">
              <h4 className={`text-md font-semibold mb-3 text-left transition-all duration-300 ${
                activePaymentMethod === 'nets-qr-web' 
                  ? 'text-blue-600 bg-blue-50 px-3 py-2 rounded-md border-l-4 border-blue-600' 
                  : 'text-blue-600'
              }`}>NETS QR (Web)</h4>
              <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
                Once you have completed the NETS QR Web coursework, generate the QR code but avoid scanning and don't make any payment yet. For certification, you are required to get a green tick for a successful transaction and a red cross for a timeout. The txn_id and txn_retrieval_ref only appear in the console if the QR code is displayed but not scanned, or before the 5-minute timeout occurs. To view them, right-click on the page and select 'Inspect'.
              </p>
              <img
                src={SandboxNetsQrWebInspect}
                alt="NETS QR Web - Console Inspection"
                className="shadow-md rounded-md mb-4 w-full max-w-md ml-0 cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(SandboxNetsQrWebInspect)}
              />
              <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
                Once you have clicked 'Inspect', click on the 'Console' tab. Look for the second object that is logged and expand it. Then expand the data, expand the result, expand the data again. That is where you are able to obtain your txn_retrieval_ref number. You are also able to obtain the txn_id from the 'README' file.
              </p>
              <img
                src={SandboxNetsQrWebConsole}
                alt="NETS QR Web - Console Data"
                className="shadow-md rounded-md mb-4 w-full max-w-md ml-0 cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(SandboxNetsQrWebConsole)}
              />
               <h5 className="text-md font-semibold text-gray-800 mb-3 mt-6 text-left">Successful Payment</h5>
              <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
                After you have obtained your payment success txn_id and txn_retrieval_ref, make payment with the TWallet NETS Simulator Payment Android App. Ensure transaction is successful and the green tick appears like the image below.
              </p>
          <div className="flex flex-col sm:flex-row gap-4 mb-4 items-center justify-center">
            <img
              src={SandboxNetsQrWebSuccess}
              alt="NETS Download Folder Sandbox"
              className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(SandboxNetsQrWebSuccess)}
            />
            <span className="text-gray-600 font-bold text-sm sm:text-base sm:flex-shrink-0">➜</span>
            <img
              src={CertificationFormSandboxNetsQrWebSuccess}
              alt="NETS Download Folder PayTech"
              className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(CertificationFormSandboxNetsQrWebSuccess)}
            />
          </div>
              <h5 className="text-md font-semibold text-gray-800 mb-3 mt-6 text-left">Unsuccessful Payment (Timeout)</h5>
              <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
                For payment timeout txn_id and txn_retrieval_ref, you can repeat the steps above but instead of scanning, you will need to wait for 5 minutes for payment timeout and the red cross will appear like the image below.
              </p>
              <p className="text-sm sm:text-base text-red-600 mb-4 sm:mb-6 text-left">
                <b>Note: Do not navigate away, minimize browser or refresh the page. Remain on the QR code page for 5 minutes until the red cross is shown. </b>
              </p>
          <div className="flex flex-col sm:flex-row gap-4 mb-4 items-center justify-center">
            <img
              src={SandboxNetsQrWebFail}
              alt="NETS Download Folder Sandbox"
              className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(SandboxNetsQrWebFail)}
            />
            <span className="text-gray-600 font-bold text-sm sm:text-base sm:flex-shrink-0">➜</span>
            <img
              src={CertificationFormSandboxNetsQrWebTimeout}
              alt="NETS Download Folder PayTech"
              className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(CertificationFormSandboxNetsQrWebTimeout)}
            />
          </div>
              
            </div>

            {/* NETS QR Mobile Section */}
            <div id="payment-method-nets-qr-mobile" className="mb-8 scroll-mt-32">
              <h4 className={`text-md font-semibold mb-3 text-left transition-all duration-300 ${
                activePaymentMethod === 'nets-qr-mobile' 
                  ? 'text-blue-600 bg-blue-50 px-3 py-2 rounded-md border-l-4 border-blue-600' 
                  : 'text-blue-600'
              }`}>NETS QR (Mobile)</h4>
              <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
                Once you have completed the NETS QR Mobile coursework, generate the QR code but avoid scanning and don't make any payment yet in the left image. For certification, you are required to get a green tick for a successful transaction and a red cross for a timeout. The txn_id and txn_retrieval_ref only appear in the console if the QR code is displayed but not scanned, or before the 5-minute timeout occurs. The txn_id can be retrieved from the 'README' file. The txn_retrieval_ref can be obtained from the Android Studio console in the right image.
              </p>
              
          <div className="flex flex-col sm:flex-row gap-4 mb-4 items-center justify-center">
            <img
              src={SandboxNetsQrMobile}
              alt="NETS Download Folder Sandbox"
              className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
              style={{ width: "150px", height: "auto" }}
              onClick={() => openImageModal(SandboxNetsQrMobile)}
            />
            <span className="text-gray-600 font-bold text-sm sm:text-base sm:flex-shrink-0">➜</span>
            <img
              src={SandboxNetsQrMobileRetrievalRef}
              alt="NETS Download Folder PayTech"
              className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(SandboxNetsQrMobileRetrievalRef)}
            />
          </div>
        <h5 className="text-md font-semibold text-gray-800 mb-3 mt-6 text-left">Successful Payment</h5>
              <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
                After you have obtained your payment success txn_id and txn_retrieval_ref, make payment with the TWallet NETS Simulator Payment Android App. Ensure transaction is successful and the green tick appears like the image below.
              </p>
          <div className="flex flex-col sm:flex-row gap-4 mb-4 items-center justify-center">
            <img
              src={SandboxNetsQrMobileSuccess}
              alt="NETS Download Folder Sandbox"
              className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
              style={{ width: "150px", height: "auto" }}
              onClick={() => openImageModal(SandboxNetsQrMobileSuccess)}
            />
            <span className="text-gray-600 font-bold text-sm sm:text-base sm:flex-shrink-0">➜</span>
            <img
              src={CertificationFormSandboxNetsQrMobileSuccess}
              alt="NETS Download Folder PayTech"
              className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(CertificationFormSandboxNetsQrMobileSuccess)}
            />
          </div>
          <h5 className="text-md font-semibold text-gray-800 mb-3 mt-6 text-left">Unsuccessful Payment (Timeout)</h5>
              <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
                For payment timeout txn_id and txn_retrieval_ref, you can repeat the steps above but instead of scanning, you will need to wait for 5 minutes for payment timeout and the red cross will appear like the image below.
              </p>
              <p className="text-sm sm:text-base text-red-600 mb-4 sm:mb-6 text-left">
                <b>Note: Do not navigate away or refresh the page. Remain on the QR code page for 5 minutes until the red cross is shown. </b>
              </p>
          <div className="flex flex-col sm:flex-row gap-4 mb-4 items-center justify-center">
            <img
              src={SandboxNetsQrMobileFail}
              alt="NETS Download Folder Sandbox"
              className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
              style={{ width: "150px", height: "auto" }}
              onClick={() => openImageModal(SandboxNetsQrMobileFail)}
            />
            <span className="text-gray-600 font-bold text-sm sm:text-base sm:flex-shrink-0">➜</span>
            <img
              src={CertificationFormSandboxNetsQrMobileTimeout}
              alt="NETS Download Folder PayTech"
              className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(CertificationFormSandboxNetsQrMobileTimeout)}
            />
          </div>

          
            </div>

            {/* eNETS Web Section */}
            <div id="payment-method-enets-web" className="mb-8 scroll-mt-32">
              <h4 className={`text-md font-semibold mb-3 text-left transition-all duration-300 ${
                activePaymentMethod === 'enets-web' 
                  ? 'text-blue-600 bg-blue-50 px-3 py-2 rounded-md border-l-4 border-blue-600' 
                  : 'text-blue-600'
              }`}>eNETS (Web)</h4>
              <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
                Once you have completed eNETS Web, click on 'Generate eNETS' and choose any of the three payment options available (eNETS Debit, Visa/Mastercard, eNETS QR). Click on 'Next' but do not complete the payment yet.
              </p>
            </div>
             <img
                src={SandboxEnetsWebHome}
                alt="NETS QR Mobile - Console Retrieval"
                className="shadow-md rounded-md mb-4 w-full max-w-md ml-0 cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(SandboxEnetsWebHome)}
              />
              <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
                For this example, select the third payment option which is 'eNETS QR'.
              </p>
                <img
                src={SandboxEnetsWebPaymentMethods}
                alt="NETS QR Mobile - Console Retrieval"
                className="shadow-md rounded-md mb-4 w-full max-w-md ml-0 cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(SandboxEnetsWebPaymentMethods)}
              />
              <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
                Once you are in the QR page,  right-click on the page and select 'Inspect'.
              </p>
              <img
                src={SandboxEnetsWebInspect}
                alt="NETS QR Mobile - Console Retrieval"
                className="shadow-md rounded-md mb-4 w-full max-w-md ml-0 cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(SandboxEnetsWebInspect)}
              />
            
              <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
                Once you have clicked 'Inspect', click on the 'Console' tab. Expand the first log and get your retrieval_ref. The txn_id can be retrieved from the 'README' file.
              </p>
              <img
                src={SandboxEnetsWebConsole}
                alt="NETS QR Mobile - Console Retrieval"
                className="shadow-md rounded-md mb-4 w-full max-w-md ml-0 cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(SandboxEnetsWebConsole)}
              />
              <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
                Note that the steps to retrieve txn_id and txn_retrieval_ref are similar for all three payment methods (eNETS Debit, Visa/Mastercard, eNETS QR). Below are the screenshots for successful and unsuccessful payments for all three payment methods. Refer to the 'README' file for more detailed steps for testing the different payment options.
              </p>
            <h5 className="text-md font-semibold text-gray-800 mb-3 mt-6 text-left">Successful Payment for Payment method: eNETS Debit</h5>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              After you have obtained your txn_id and txn_retrieval_ref, complete the payment process. Ensure transaction is successful and the green tick appears like the image below. When inputting into the certification form, ensure it is in the correct fields (eNETS Debit).
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mb-4 items-center justify-center">
              <img
                src={SandboxEnetsWebDebitSuccess}
                alt="NETS Download Folder Sandbox"
                className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(SandboxEnetsWebDebitSuccess)}
              />
              <span className="text-gray-600 font-bold text-sm sm:text-base sm:flex-shrink-0">➜</span>
              <img
                src={CertificationFormSandboxEnetsWebDebitSuccess}
                alt="NETS Download Folder PayTech"
                className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(CertificationFormSandboxEnetsWebDebitSuccess)}
              />
            </div>

            <h5 className="text-md font-semibold text-gray-800 mb-3 mt-6 text-left">Successful Payment for Payment method: Visa/Mastercard</h5>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              After you have obtained your txn_id and txn_retrieval_ref, complete the payment process. Ensure transaction is successful and the green tick appears like the image below. When inputting into the certification form, ensure it is in the correct fields (Visa/Mastercard).
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mb-4 items-center justify-center">
              <img
                src={SandboxEnetsWebCreditSuccess}
                alt="NETS Download Folder Sandbox"
                className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(SandboxEnetsWebCreditSuccess)}
              />
              <span className="text-gray-600 font-bold text-sm sm:text-base sm:flex-shrink-0">➜</span>
              <img
                src={CertificationFormSandboxEnetsWebCreditSuccess}
                alt="NETS Download Folder PayTech"
                className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(CertificationFormSandboxEnetsWebCreditSuccess)}
              />
            </div>

            <h5 className="text-md font-semibold text-gray-800 mb-3 mt-6 text-left">Successful Payment for Payment method: eNETS QR</h5>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              After you have obtained your txn_id and txn_retrieval_ref, complete the payment process with the TWallet NETS Simulator Payment Android App. Ensure transaction is successful and the green tick appears like the image below. When inputting into the certification form, ensure it is in the correct fields (eNETS QR)
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mb-4 items-center justify-center">
              <img
                src={SandboxEnetsWebQrSuccess}
                alt="NETS Download Folder Sandbox"
                className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(SandboxEnetsWebQrSuccess)}
              />
              <span className="text-gray-600 font-bold text-sm sm:text-base sm:flex-shrink-0">➜</span>
              <img
                src={CertificationFormSandboxEnetsWebQrSuccess}
                alt="NETS Download Folder PayTech"
                className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(CertificationFormSandboxEnetsWebQrSuccess)}
              />
            </div>

            <h5 className="text-md font-semibold text-gray-800 mb-3 mt-6 text-left">Unsuccessful Payment (Timeout) for Payment method: eNETS Debit | VISA/MasterCard</h5>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              For transaction timeout txn_id and txn_retrieval_ref, you can repeat the steps above but instead of completing the payment process, you will need to wait for 10 minutes for payment timeout and the red cross will appear like the image below. Either eNETS Debit or VISA/MasterCard can be used for timeout testing. When inputting into the certification form, ensure it is in the correct fields (eNETS Debit or VISA/MasterCard).
            </p>
            <p className="text-sm sm:text-base text-red-600 mb-4 sm:mb-6 text-left">
              <b>Note: Do not navigate away, minimize browser or refresh the page. Remain on the eNETS or VISA/MasterCard page for 10 minutes until the red cross is shown. </b>
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mb-4 items-center justify-center">
              <img
                src={SandboxEnetsWebDebitCreditFail}
                alt="NETS Download Folder Sandbox"
                className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(SandboxEnetsWebDebitCreditFail)}
              />
              <span className="text-gray-600 font-bold text-sm sm:text-base sm:flex-shrink-0">➜</span>
              <img
                src={CertificationFormSandboxEnetsWebDebitCreditTimeout}
                alt="NETS Download Folder PayTech"
                className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(CertificationFormSandboxEnetsWebDebitCreditTimeout)}
              />
            </div>

            <h5 className="text-md font-semibold text-gray-800 mb-3 mt-6 text-left">Unsuccessful Payment (Timeout) for Payment method: eNETS QR</h5>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              For transaction timeout txn_id and txn_retrieval_ref, you can repeat the steps above but instead of scanning, you will need to wait for 2 minutes for payment timeout and the red cross will appear like the image below. When inputting into the certification form, ensure it is in the correct fields (eNETS QR).
            </p>
            <p className="text-sm sm:text-base text-red-600 mb-4 sm:mb-6 text-left">
              <b>Note: Do not navigate away, minimize browser or refresh the page. Remain on the QR code page for 2 minutes until the red cross is shown. </b>
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mb-4 items-center justify-center">
              <img
                src={SandboxEnetsWebQrFail}
                alt="NETS Download Folder Sandbox"
                className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(SandboxEnetsWebQrFail)}
              />
              <span className="text-gray-600 font-bold text-sm sm:text-base sm:flex-shrink-0">➜</span>
              <img
                src={CertificationFormSandboxEnetsWebQrTimeout}
                alt="NETS Download Folder PayTech"
                className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(CertificationFormSandboxEnetsWebQrTimeout)}
              />
            </div>
            
          </div>

                    {/* Step 7 */}
          <div id="step7" ref={step7Ref} data-step="7" className="scroll-mt-24 mb-8 sm:mb-12">
            <h3 className="text-lg font-semibold text-gray-800 mb-3 sm:mb-4 text-left">Step 7 | Get Certified</h3>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Once you have obtained the txn_id and txn_retrieval_ref, click on your Sandbox project and click 'Get Course Certificate'
            </p>
            <img
              src={SandboxCourseCertificate}
              alt="NETS Certification Process Sandbox"
              className="shadow-md rounded-md mb-4 w-full max-w-md ml-0 cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(SandboxCourseCertificate)}
            />
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Input the full name to be displayed in the certificate and provide your school email for verification purposes.
            </p>
            <img
              src={SandboxCourseCertificateDetails}
              alt="NETS Certification Process Sandbox"
              className="shadow-md rounded-md mb-4 w-full max-w-md ml-0 cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(SandboxCourseCertificateDetails)}
            />
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
            Once you’ve entered your full name and school email, choose your payment method and fill in the txn_id and txn_retrieval_ref. In the screenshot below, since “NETS QR (Mobile)” was selected, you need to provide the NETS QR txn_retrieval_ref for successful payment (Green Tick) and payment timeout (Red Cross).
            </p>
            <img
              src={CertificationFormSandbox}
              alt="NETS Certification Process Sandbox"
              className="shadow-md rounded-md mb-4 w-full max-w-md ml-0 cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(CertificationFormSandbox)}
            />
          </div>

            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              <strong>Congratulations!</strong> You have completed all the required steps for NETS Sandbox certification. Your certificate will serve as proof of your competency in implementing NETS payment solutions in Sandbox environment. Your certificate may be downloaded in 1 month after verification checks are completed.
            </p>

              <img
                src={CertificationStatusReleased}
                alt="NETS Certification Process Sandbox"
                className="shadow-md rounded-md w-full max-w-md ml-0 cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(CertificationStatusReleased)}
              />
          

          <div className="mt-8 sm:mt-10 text-left">
            <a 
              href="/certification-journey" 
              className="bg-blue-600 hover:bg-blue-700 text-white py-2 sm:py-3 px-4 sm:px-6 rounded-md text-sm sm:text-base font-medium transition duration-300"
            >
              Back to Certification Journey
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default SandboxNetsCertificationLayout;